import { isEmbeddedPollVotable } from "./embedded-poll-votable";
import { hasSubmittedVoteForPoll } from "./vote-submission";

// Which embedded polls BLOCK an attending session vote? A poll blocks when it is
// `required`, still answerable by this participant (OPEN, not FINALIZED/CLOSED,
// deadline not passed, accepted participant, scheduler live), AND has no submitted
// vote from them yet. Closed / past-deadline / finalized / cancelled-scheduler
// required polls are EXEMPT so the gate is always satisfiable — a participant can
// never be locked out of voting by a poll they can no longer answer. A *draft*
// (unsubmitted) selection does not satisfy the gate; the embedded vote must be
// submitted (`hasSubmittedVoteForPoll`).
//
// Pure: `now` is injected and never read from the clock here, so the gate stays
// deterministic in tests. The "no times work" bypass and the attending-vote check
// live at the call site (handleSave) — this helper only computes the list.
export function getUnansweredRequiredEmbeddedPolls({
  embeddedPolls,
  myVotesByPollId,
  isAcceptedParticipant,
  canGuestVote = false,
  schedulerCancelled,
  now = Date.now(),
}) {
  if (!Array.isArray(embeddedPolls)) return [];
  return embeddedPolls.filter((poll) => {
    if (!poll?.required) return false;
    if (
      !isEmbeddedPollVotable({
        poll,
        isAcceptedParticipant,
        canGuestVote,
        schedulerCancelled,
        now,
      })
    ) {
      return false;
    }
    // Only gate once we've actually received this poll's my-vote snapshot. A
    // MISSING entry (key absent) means the per-poll my-vote listener hasn't
    // fired yet — treat as not-yet-known and DON'T block, so a submit during the
    // load window (polls list arrived, my-votes haven't) can't false-block. Once
    // the snapshot lands the entry becomes `null` (confirmed no vote → block) or
    // a vote doc (answered → don't block). The submit handler also optimistically
    // sets this entry on an embedded vote so the gate doesn't wait on the echo.
    if (
      !myVotesByPollId ||
      !Object.prototype.hasOwnProperty.call(myVotesByPollId, poll.id)
    ) {
      return false;
    }
    return !hasSubmittedVoteForPoll(poll, myVotesByPollId[poll.id]);
  });
}
